// Finished spots played on the homepage and the examples page.
// Audio files live in frontend/public/examples and are served from /examples/.
export const AD_PRICE_USD_FALLBACK = 2.99;

export const EXAMPLE_ADS = [
  {
    id: 'gym',
    business: 'Gym',
    title: 'Harbor Gym',
    script: 'This week only. Join Harbor Gym and your first month is one dollar. Classes start Monday. Walk in or book at the front desk.',
    src: '/examples/gym.mp3',
  },
  {
    id: 'restaurant',
    business: 'Restaurant',
    title: 'Maple Street Cafe',
    script: 'Friday night at Maple Street Cafe. Half-price pizzas from five to seven. Bring the family. No reservation needed.',
    src: '/examples/restaurant.mp3',
  },
  {
    id: 'realtor',
    business: 'Realtor',
    title: '18 Cedar Lane',
    script: 'Open house this Sunday, noon to three, at 18 Cedar Lane. Three bedrooms, a new kitchen, and a yard the dog will love. Ask for Dana.',
    src: '/examples/realtor.mp3',
  },
];

export function formatAdPrice(amount) {
  const n = Number(amount);
  const value = Number.isFinite(n) && n > 0 ? n : AD_PRICE_USD_FALLBACK;
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`;
}
